import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserByEmail, UserDetail, UserNotificationResponse } from '../../../models/users.model';
import { DataContextService } from '../../datacontext.service';
import { Observable, throwError } from 'rxjs';
import { AssigneeResponse, UserSearchResult } from 'src/app/models/find-a-space.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  limit: number;
  constructor(private dataContextService: DataContextService) {
    dataContextService.masterDadaLoaded$.subscribe((res) => {
      if (res) {
        this.limit = DataContextService.ROWS_PER_PAGE;
      }
    });
  }

  getUsersByEmail(emails: string[] = []) {
    let url = `Users/GetByEmails?`
    if (emails.length) {
      emails.forEach((email) =>
        url += `Emails=${email}&`
      );
    }
    return this.dataContextService.getData(url).pipe(
      map(res => {
        if (res.status === 200) {
          let users = res.data as UserByEmail[];
          users.forEach(i => {
            if (i.user) {
              i.user.firstName = this.dataContextService.getUserFirstName(i.user);
              i.user.lastName = i.user.lastName ? i.user.lastName :''
            }
          })
          return users;
        }
        else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    )
  }
  getAssignees(term: string, limit: number): Observable<UserDetail[]> {
    const url = 'Users/Assignees?Term=' + encodeURIComponent(term) + '&Limit=' + (limit || this.limit);
    return this.dataContextService.getData(url, false).pipe(
      map(res => {
        if (res.status === 200) {
          const users = res.data as UserDetail[];
          return users.map(i => {
            return {
              ...i,
              firstName: this.dataContextService.getUserFirstName(i),
              lastName: i.lastName ? i.lastName : ''
            };
          })
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }
  getUserSearch(term: string, limit: number): Observable<UserDetail[]> {
    const url = 'Users?Term=' + encodeURIComponent(term) + '&Limit=' + (limit || this.limit);
    return this.dataContextService.getData(url, false).pipe(
      map(res => {
        if (res.status === 200) {
          const users = res.data as UserDetail[];
          return users.map(i => {
            return {
              ...i,
              firstName: this.dataContextService.getUserFirstName(i),
              lastName: i.lastName ? i.lastName : ''
            };
          })
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  getUserById(userId: number): Observable<UserDetail> {
    const url = 'Users/' + userId;
    return this.dataContextService.getData(url, false).pipe(
      map(res => {
        if (res.status === 200) {
          const users = res.data as UserDetail;
          users.firstName=this.dataContextService.getUserFirstName(res.data)
          users.lastName = users.lastName ? users.lastName : ''
          return users
        } else {
          return this.dataContextService.showErrorToaster(res);
        }
      })
    );
  }

  getUsers(term: string, limit?: number): Observable<UserDetail[]> {
    const url = 'Users?Term=' + encodeURIComponent(term) + '&Limit=' + (limit || this.limit);
    return this.dataContextService.getData(url, false).pipe(map(res => {
      if (res.status === 200) {
        const users = res.data as UserDetail[];
        return users.map(i => {
          return {
            ...i,
            firstName: this.dataContextService.getUserFirstName(i),
            lastName: i.lastName ? i.lastName : ''
          };
        });
      } else {
        return this.dataContextService.showErrorToaster(res);
      }
    }));
  }

  checkOverflow(usersArray: Array<any>): boolean {
    if (usersArray.length >= DataContextService.RECOMMENDATION_LIST_PAGE_SIZE)
      return true;
    else
      return false;
  }
  removeUserNotification(id: number) {
    const url = `UserNotifications/${id}/MarkAsRead`;
    return this.dataContextService.patchData(url, {}, false).pipe(
      map((res) => res.data)
    )
  }
  getUserNotifications(): Observable<UserNotificationResponse[]> {
    const url = `UserNotifications/Unread`;
    return this.dataContextService.getData(url, false).pipe(
      map(res => res.data as UserNotificationResponse[])
    )
  }
}
